import { createSlice } from "@reduxjs/toolkit";


const themeSlice = createSlice({
    name : 'sidebarToggle',
    initialState : {
        isTheme : localStorage.getItem('theme')?localStorage.getItem('theme'):'light',
    },
    reducers : {
        themeDark : (state) =>{
            localStorage.setItem('theme','dark')
            state.isTheme = 'dark'
        },
        themeLight : (state) =>{
            localStorage.setItem('theme','light')
            state.isTheme = 'light'
        },
        themeBW : (state:any) => {
            localStorage.setItem('theme','b&w')
            state.isTheme = 'b&w'
        }
    }
})

export const {themeDark, themeLight, themeBW} = themeSlice.actions;

export default themeSlice.reducer;